// import React, { useState } from 'react';
// import { BrowserProvider, Contract, formatEther, parseEther } from 'ethers';
// import { CONTRACT_ADDRESS, CONTRACT_ABI } from '../constants';

// /**
//  * Component for creating a new event.
//  * @param {object} props - The component props.
//  * @param {Function} props.setLoading - Function to set the loading state.
//  * @param {Function} props.setMessage - Function to set the message displayed to the user.
//  * @param {Function} props.setCurrentPage - Function to change the current page.
//  * @param {Function} props.refetch - Function to refetch data from the subgraph.
//  */
// const CreateEventPage = ({ setLoading, setMessage, setCurrentPage, refetch }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     description: '',
//     date: '',
//     venue: '',
//     imageIPFS: '',
//     ticketPrice: '',
//     totalTickets: '',
//     stakeAmount: '',
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

// const handleCreateEvent = async (e) => {
//   e.preventDefault();
//   setLoading(true);
//   setMessage('');

//   try {
//     if (!window.ethereum) {
//       setMessage("MetaMask not detected. Please install it.");
//       setLoading(false);
//       return;
//     }

//     const provider = new BrowserProvider(window.ethereum);
//     const signer = await provider.getSigner();
//     const eventContract = new Contract(CONTRACT_ADDRESS, CONTRACT_ABI, signer);

//     const platformFee = parseEther("0.01");
//     const stakeAmount = parseEther(formData.stakeAmount.toString());
//     const totalValue = platformFee + stakeAmount;

//     // Convert ticket price to wei, but keep totalTickets as a regular number
//     const ticketPrice = parseEther(formData.ticketPrice.toString());
//     const totalTickets = parseInt(formData.totalTickets); // This should be a regular number, not wei

//     const tx = await eventContract.createEvent(
//       formData.name,
//       formData.description,
//       Math.floor(new Date(formData.date).getTime() / 1000),
//       formData.venue,
//       formData.imageIPFS,
//       totalTickets, // Pass as regular number
//       ticketPrice,  // Pass as wei value
//       { value: totalValue }
//     );

//     setMessage("Transaction sent. Waiting for confirmation...");
//     await tx.wait();

//     setMessage("Event created successfully!");
//     setFormData({
//       name: '',
//       description: '',
//       date: '',
//       venue: '',
//       imageIPFS: '',
//       ticketPrice: '',
//       totalTickets: '',
//       stakeAmount: '',
//     });

//     // await refetch();
//     setCurrentPage('event-list');
//   } catch (error) {
//     console.error("Error creating event:", error);
//     setMessage(`Failed to create event. Error: ${error.reason || error.message}`);
//   } finally {
//     setLoading(false);
//   }
// };

//   const cardStyle = {
//     padding: '30px',
//     backgroundColor: '#ffffff',
//     borderRadius: '12px',
//     boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
//     maxWidth: '600px',
//     margin: '40px auto',
//   };

//   const titleStyle = {
//     fontSize: '2rem',
//     fontWeight: '700',
//     textAlign: 'center',
//     color: '#333333',
//     marginBottom: '20px',
//   };

//   const formStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '20px',
//   };

//   const formGroupStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//   };

//   const labelStyle = {
//     fontWeight: '600',
//     color: '#555555',
//     marginBottom: '8px',
//   };

//   const inputStyle = {
//     padding: '12px',
//     border: '1px solid #e0e0e0',
//     borderRadius: '8px',
//     fontSize: '1rem',
//     backgroundColor: '#f9f9f9',
//     color: '#333333',
//   };

//   const textareaStyle = {
//     ...inputStyle,
//     resize: 'vertical',
//   };

//   const buttonStyle = {
//     padding: '12px 25px',
//     borderRadius: '8px',
//     fontSize: '1rem',
//     fontWeight: '600',
//     cursor: 'pointer',
//     border: 'none',
//     backgroundColor: '#6c63ff',
//     color: 'white',
//     transition: 'background-color 0.3s ease, transform 0.2s ease',
//   };

//   const buttonHoverStyle = {
//     backgroundColor: '#5a53e6',
//     transform: 'translateY(-2px)',
//   };

//   const helpTextStyle = {
//     fontSize: '0.85rem',
//     color: '#888888',
//     marginTop: '5px',
//   };

//   return (
//     <div style={cardStyle}>
//       <h2 style={titleStyle}>Create New Event</h2>
//       <form onSubmit={handleCreateEvent} style={formStyle}>
//         <div style={formGroupStyle}>
//           <label htmlFor="name" style={labelStyle}>Event Name</label>
//           <input
//             type="text"
//             id="name"
//             name="name"
//             value={formData.name}
//             onChange={handleChange}
//             required
//             style={inputStyle}
//           />
//         </div>
//         <div style={formGroupStyle}>
//           <label htmlFor="description" style={labelStyle}>Description</label>
//           <textarea
//             id="description"
//             name="description"
//             value={formData.description}
//             onChange={handleChange}
//             required
//             rows="3"
//             style={textareaStyle}
//           ></textarea>
//         </div>
//         <div style={formGroupStyle}>
//           <label htmlFor="date" style={labelStyle}>Event Date</label>
//           <input
//             type="datetime-local"
//             id="date"
//             name="date"
//             value={formData.date}
//             onChange={handleChange}
//             required
//             style={inputStyle}
//           />
//         </div>
//         <div style={formGroupStyle}>
//           <label htmlFor="venue" style={labelStyle}>Venue</label>
//           <input
//             type="text"
//             id="venue"
//             name="venue"
//             value={formData.venue}
//             onChange={handleChange}
//             required
//             style={inputStyle}
//           />
//         </div>
//         <div style={formGroupStyle}>
//           <label htmlFor="imageIPFS" style={labelStyle}>Image IPFS CID</label>
//           <input
//             type="text"
//             id="imageIPFS"
//             name="imageIPFS"
//             value={formData.imageIPFS}
//             onChange={handleChange}
//             required
//             style={inputStyle}
//           />
//         </div>
//         <div style={formGroupStyle}>
//           <label htmlFor="ticketPrice" style={labelStyle}>Base Ticket Price (ETH)</label>
//           <input
//             type="number"
//             id="ticketPrice"
//             name="ticketPrice"
//             value={formData.ticketPrice}
//             onChange={handleChange}
//             required
//             min="0.001"
//             step="0.001"
//             style={inputStyle}
//           />
//         </div>
//         <div style={formGroupStyle}>
//           <label htmlFor="totalTickets" style={labelStyle}>Total Tickets</label>
//           <input
//             type="number"
//             id="totalTickets"
//             name="totalTickets"
//             value={formData.totalTickets}
//             onChange={handleChange}
//             required
//             min="1"
//             style={inputStyle}
//           />
//         </div>
//         <div style={formGroupStyle}>
//           <label htmlFor="stakeAmount" style={labelStyle}>Stake Amount (ETH)</label>
//           <input
//             type="number"
//             id="stakeAmount"
//             name="stakeAmount"
//             value={formData.stakeAmount}
//             onChange={handleChange}
//             required
//             min="0.001"
//             step="0.001"
//             style={inputStyle}
//           />
//           <p style={helpTextStyle}>This is returned after the event, minus a 30% penalty if not claimed.</p>
//         </div>
//         <button
//           type="submit"
//           style={buttonStyle}
//           onMouseOver={(e) => Object.assign(e.currentTarget.style, buttonHoverStyle)}
//           onMouseOut={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
//         >
//           Create Event
//         </button>
//       </form>
//     </div>
//   );
// };

// export default CreateEventPage;










import React, { useState } from 'react';
import { BrowserProvider, Contract, formatEther, parseEther } from 'ethers';
import { CONTRACT_ADDRESS, CONTRACT_ABI } from '../constants';

/**
 * Component for creating a new event.
 * @param {object} props - The component props.
 * @param {Function} props.setLoading - Function to set the loading state.
 * @param {Function} props.setMessage - Function to set the message displayed to the user.
 * @param {Function} props.setCurrentPage - Function to change the current page.
 * @param {Function} props.refetch - Function to refetch data from the subgraph.
 */
const CreateEventPage = ({ setLoading, setMessage, setCurrentPage, refetch }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    date: '',
    venue: '',
    imageIPFS: '',
    ticketPrice: '',
    totalTickets: '',
    stakeAmount: '',
  });

  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);

  // Pinata configuration
  const PINATA_API_KEY = 'ecf2ec311067508c9805';
  const PINATA_SECRET_KEY = '8b898c0c9b6cce79734fc4d9d2cc1feb4886d3875f14695a10da846407e567b3';
  const PINATA_JWT = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiJhODgyM2ViOC00Mjg4LTQ3NjQtOWIyYy1jZjZmMGY4YTY5YjgiLCJlbWFpbCI6InN1bWFudGh2ZXNsYXZhdGgwN0BnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicGluX3BvbGljeSI6eyJyZWdpb25zIjpbeyJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MSwiaWQiOiJGUkExIn0seyJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MSwiaWQiOiJOWUMxIn1dLCJ2ZXJzaW9uIjoxfSwibWZhX2VuYWJsZWQiOmZhbHNlLCJzdGF0dXMiOiJBQ1RJVkUifSwiYXV0aGVudGljYXRpb25UeXBlIjoic2NvcGVkS2V5Iiwic2NvcGVkS2V5S2V5IjoiZWNmMmVjMzExMDY3NTA4Yzk4MDUiLCJzY29wZWRLZXlTZWNyZXQiOiI4Yjg5OGMwYzliNmNjZTc5NzM0ZmM0ZDlkMmNjMWZlYjQ4ODZkMzg3NWYxNDY5NWExMGRhODQ2NDA3ZTU2N2IzIiwiZXhwIjoxNzg4MDI3MzI1fQ.hFFFqjZ_Rx14n0xzeP-5E32VlZ-uH314ElnsPU_XNaI';

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
      if (!validTypes.includes(file.type)) {
        setMessage('Please select a valid image file (JPEG, PNG, GIF, or WebP)');
        return;
      }

      // Validate file size (max 10MB)
      if (file.size > 10 * 1024 * 1024) {
        setMessage('Image size should be less than 10MB');
        return;
      }

      setSelectedImage(file);
      
      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
      
      // Clear any previous IPFS hash
      setFormData({ ...formData, imageIPFS: '' });
    }
  };

  const uploadToPinata = async () => {
    if (!selectedImage) {
      setMessage('Please select an image first');
      return null;
    }

    setUploadingImage(true);
    setMessage('Uploading image to IPFS...');

    try {
      const formData = new FormData();
      formData.append('file', selectedImage);

      const metadata = JSON.stringify({
        name: `Event Logo - ${Date.now()}`,
        keyvalues: {
          eventName: formData.name || 'Unknown Event',
          uploadedAt: new Date().toISOString()
        }
      });
      formData.append('pinataMetadata', metadata);

      const options = JSON.stringify({
        cidVersion: 0,
      });
      formData.append('pinataOptions', options);

      const response = await fetch('https://api.pinata.cloud/pinning/pinFileToIPFS', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${PINATA_JWT}`
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error(`Upload failed: ${response.statusText}`);
      }

      const result = await response.json();
      setMessage('Image uploaded successfully to IPFS!');
      
      // Update the formData with the IPFS hash
      setFormData(prev => ({ ...prev, imageIPFS: result.IpfsHash }));
      
      return result.IpfsHash;
    } catch (error) {
      console.error('Error uploading to Pinata:', error);
      setMessage(`Failed to upload image: ${error.message}`);
      return null;
    } finally {
      setUploadingImage(false);
    }
  };

  const handleCreateEvent = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      // Upload image to IPFS if one is selected
      let ipfsHash = formData.imageIPFS;
      if (selectedImage && !ipfsHash) {
        ipfsHash = await uploadToPinata();
        if (!ipfsHash) {
          setLoading(false);
          return;
        }
      }

      if (!window.ethereum) {
        setMessage("MetaMask not detected. Please install it.");
        setLoading(false);
        return;
      }

      const provider = new BrowserProvider(window.ethereum);
      const signer = await provider.getSigner();
      const eventContract = new Contract(CONTRACT_ADDRESS, CONTRACT_ABI, signer);

      const platformFee = parseEther("0.01");
      const stakeAmount = parseEther(formData.stakeAmount.toString());
      const totalValue = platformFee + stakeAmount;

      // Convert ticket price to wei, but keep totalTickets as a regular number
      const ticketPrice = parseEther(formData.ticketPrice.toString());
      const totalTickets = parseInt(formData.totalTickets); // This should be a regular number, not wei

      const tx = await eventContract.createEvent(
        formData.name,
        formData.description,
        Math.floor(new Date(formData.date).getTime() / 1000),
        formData.venue,
        ipfsHash, // Use the IPFS hash from upload
        totalTickets, // Pass as regular number
        ticketPrice,  // Pass as wei value
        { value: totalValue }
      );

      setMessage("Transaction sent. Waiting for confirmation...");
      await tx.wait();

      setMessage("Event created successfully!");
      setFormData({
        name: '',
        description: '',
        date: '',
        venue: '',
        imageIPFS: '',
        ticketPrice: '',
        totalTickets: '',
        stakeAmount: '',
      });

      // Reset image states
      setSelectedImage(null);
      setImagePreview(null);

      // await refetch();
      setCurrentPage('event-list');
    } catch (error) {
      console.error("Error creating event:", error);
      setMessage(`Failed to create event. Error: ${error.reason || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const cardStyle = {
    padding: '30px',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    maxWidth: '600px',
    margin: '40px auto',
  };

  const titleStyle = {
    fontSize: '2rem',
    fontWeight: '700',
    textAlign: 'center',
    color: '#333333',
    marginBottom: '20px',
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  };

  const formGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
  };

  const labelStyle = {
    fontWeight: '600',
    color: '#555555',
    marginBottom: '8px',
  };

  const inputStyle = {
    padding: '12px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '1rem',
    backgroundColor: '#f9f9f9',
    color: '#333333',
  };

  const textareaStyle = {
    ...inputStyle,
    resize: 'vertical',
  };

  const buttonStyle = {
    padding: '12px 25px',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    border: 'none',
    backgroundColor: '#6c63ff',
    color: 'white',
    transition: 'background-color 0.3s ease, transform 0.2s ease',
  };

  const buttonHoverStyle = {
    backgroundColor: '#5a53e6',
    transform: 'translateY(-2px)',
  };

  const helpTextStyle = {
    fontSize: '0.85rem',
    color: '#888888',
    marginTop: '5px',
  };

  const imagePreviewStyle = {
    width: '100%',
    maxWidth: '200px',
    height: '120px',
    objectFit: 'cover',
    borderRadius: '8px',
    border: '2px solid #e0e0e0',
    marginTop: '10px',
  };

  const uploadButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#28a745',
    marginTop: '10px',
    fontSize: '0.9rem',
    padding: '8px 16px',
  };

  const uploadButtonHoverStyle = {
    backgroundColor: '#218838',
    transform: 'translateY(-1px)',
  };

  return (
    <div style={cardStyle}>
      <h2 style={titleStyle}>Create New Event</h2>
      <form onSubmit={handleCreateEvent} style={formStyle}>
        <div style={formGroupStyle}>
          <label htmlFor="name" style={labelStyle}>Event Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            style={inputStyle}
          />
        </div>
        
        <div style={formGroupStyle}>
          <label htmlFor="description" style={labelStyle}>Description</label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
            rows="3"
            style={textareaStyle}
          ></textarea>
        </div>
        
        <div style={formGroupStyle}>
          <label htmlFor="date" style={labelStyle}>Event Date</label>
          <input
            type="datetime-local"
            id="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            required
            style={inputStyle}
          />
        </div>
        
        <div style={formGroupStyle}>
          <label htmlFor="venue" style={labelStyle}>Venue</label>
          <input
            type="text"
            id="venue"
            name="venue"
            value={formData.venue}
            onChange={handleChange}
            required
            style={inputStyle}
          />
        </div>
        
        <div style={formGroupStyle}>
          <label htmlFor="eventImage" style={labelStyle}>Event Logo/Image</label>
          <input
            type="file"
            id="eventImage"
            accept="image/*"
            onChange={handleImageChange}
            required
            style={inputStyle}
          />
          <p style={helpTextStyle}>
            Upload an image for your event (JPEG, PNG, GIF, or WebP, max 10MB)
          </p>
          
          {imagePreview && (
            <div>
              <img 
                src={imagePreview} 
                alt="Event preview" 
                style={imagePreviewStyle}
              />
              {!formData.imageIPFS && selectedImage && (
                <button
                  type="button"
                  onClick={uploadToPinata}
                  disabled={uploadingImage}
                  style={uploadButtonStyle}
                  onMouseOver={(e) => !uploadingImage && Object.assign(e.currentTarget.style, uploadButtonHoverStyle)}
                  onMouseOut={(e) => Object.assign(e.currentTarget.style, uploadButtonStyle)}
                >
                  {uploadingImage ? 'Uploading...' : 'Upload to IPFS'}
                </button>
              )}
              {formData.imageIPFS && (
                <p style={{...helpTextStyle, color: '#28a745', marginTop: '5px'}}>
                  ✅ Image uploaded successfully! IPFS: {formData.imageIPFS}
                </p>
              )}
            </div>
          )}
        </div>
        
        <div style={formGroupStyle}>
          <label htmlFor="ticketPrice" style={labelStyle}>Base Ticket Price (ETH)</label>
          <input
            type="number"
            id="ticketPrice"
            name="ticketPrice"
            value={formData.ticketPrice}
            onChange={handleChange}
            required
            min="0.001"
            step="0.001"
            style={inputStyle}
          />
        </div>
        
        <div style={formGroupStyle}>
          <label htmlFor="totalTickets" style={labelStyle}>Total Tickets</label>
          <input
            type="number"
            id="totalTickets"
            name="totalTickets"
            value={formData.totalTickets}
            onChange={handleChange}
            required
            min="1"
            style={inputStyle}
          />
        </div>
        
        <div style={formGroupStyle}>
          <label htmlFor="stakeAmount" style={labelStyle}>Stake Amount (ETH)</label>
          <input
            type="number"
            id="stakeAmount"
            name="stakeAmount"
            value={formData.stakeAmount}
            onChange={handleChange}
            required
            min="0.001"
            step="0.001"
            style={inputStyle}
          />
          <p style={helpTextStyle}>This is returned after the event, minus a 30% penalty if not claimed.</p>
        </div>
        
        <button
          type="submit"
          disabled={selectedImage && !formData.imageIPFS}
          style={{
            ...buttonStyle,
            backgroundColor: (selectedImage && !formData.imageIPFS) ? '#cccccc' : '#6c63ff',
            cursor: (selectedImage && !formData.imageIPFS) ? 'not-allowed' : 'pointer'
          }}
          onMouseOver={(e) => {
            if (!(selectedImage && !formData.imageIPFS)) {
              Object.assign(e.currentTarget.style, buttonHoverStyle);
            }
          }}
          onMouseOut={(e) => {
            Object.assign(e.currentTarget.style, {
              ...buttonStyle,
              backgroundColor: (selectedImage && !formData.imageIPFS) ? '#cccccc' : '#6c63ff'
            });
          }}
        >
          Create Event
        </button>
        
        {selectedImage && !formData.imageIPFS && (
          <p style={{...helpTextStyle, color: '#ff6b6b', textAlign: 'center'}}>
            Please upload your image to IPFS before creating the event
          </p>
        )}
      </form>
    </div>
  );
};

export default CreateEventPage;